import * as React from 'react';
import APIManager from '../../../utilities/api-manager';
import { getConfig } from '../../../helpers';
import SPGVariables from '../../../utilities/spg-variables';

const spgVariables = SPGVariables();

const VisualizationAuth = ({ isLoggedIn, isTableauSessionCreated, toggleSessionCreate }: VisualizationAuthProps) => {
    const baseUrl = getConfig('urls.tableau');

    const [token, setToken] = React.useState<string>();
    if (isLoggedIn && isTableauSessionCreated === false && token === undefined) {
        APIManager.getTableauSessionTicket().then(response => {
            setToken(response.data);
        });
    }
    const style = { display: 'none' };

    const secureView = token ? <iframe onLoad={() => toggleSessionCreate(true)} style={style} title="secureView" src={`${baseUrl}trusted/${token}/t/${spgVariables.TABLEAU_SECURESITE}/views/blank-auth/Token?:embed=true`} /> : null;

    return secureView;
};

export default VisualizationAuth;
